// Cadre commun aux pages légales et à la page contact.
// Barre de navigation, titre, contenu en colonne étroite, pied de page.
import { useLocation } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import { useT } from '../../lib/i18n'
import { useSeo } from '../../lib/seo'

export default function LegalShell ({ title, intro, updated, children, description, noindex = false }) {
  const t = useT()
  const { pathname } = useLocation()

  // Titre d'onglet, description et canonique. Le chapô sert d'extrait
  // Google faute de mieux : il dit déjà de quoi parle la page.
  useSeo({
    title,
    description: description || intro || title,
    path: pathname,
    noindex
  })

  return (
    <div className="u">
      <Navbar />

      <main className="u-legal">
        <div className="u-wrap">
          <header className="u-legal__head">
            <h1 className="u-h2 u-h2--caps">{title}</h1>
            {intro && <p className="u-legal__intro">{intro}</p>}
            {updated && <p className="u-legal__date">{t.legal.shell.updated(updated)}</p>}
          </header>

          <div className="u-legal__body">{children}</div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
